import { css } from '@adornis/chemistry/directives/css';
import { XNativeDialog } from '@adornis/dialog/x-native-dialog';
import { html } from 'lit';
import { firstValueFrom, timer } from 'rxjs';
import { CreateDraft } from '../../drafts/client/CreateDraft';
import { Draft, DraftStatusFactory } from '../../drafts/db/Draft';

export const CreateCorrectionByEntityDialog = ({
  draftClassName,
  _id,
  _class,
  userID,
  onAfterCorrectionCreated,
}: {
  draftClassName: string;
  _id: string;
  _class: string;
  userID: string;
  onAfterCorrectionCreated?: (draft: Draft) => void;
}) => {
  return XNativeDialog.showPopup<void>({
    content: (resolve, reject, dialogElement) => {
      return html`
        <x-flex ${css({ width: `800px`, padding: '24px' })} space="md">
          <d-h4> Neue Korrektur anlegen </d-h4>
          ${CreateDraft({
            draftClassName,
            reference: { _id, _class },
            draftTemplate: new Draft({
              name: '',
              description: '',
              status: DraftStatusFactory.create('IN_REVIEW'),
              assignedReviewer: userID,
            }),
            onAfterCreateCallback: draft => {
              if (!onAfterCorrectionCreated) return resolve();

              XNativeDialog.waitFor(
                Promise.all([firstValueFrom(timer(1000)), onAfterCorrectionCreated(draft)]),
                'Du wirst zur Korrektur weitergeleitet...',
              ).then(() => resolve());
            },
          })}
        </x-flex>
      `;
    },
  });
};
